
  import {Vue, Component,} from "vue-property-decorator";
  import {IApp} from "@/interfaces/app.interface";
  import ROUTE_NAME = IApp.ROUTE_NAME;
  import BarrierButton from "@/modules/barriers/components/BarrierButton.vue";
  import BalanceMenuButton from "@/modules/Payment/components/BalanceMenuButton.vue";
  import {ANONYMOUS_PAGE} from "@/modules/Auth/stores/auth.store";
  import {ICarList} from "@/modules/CarList/interfaces/car-list.interface";
  import {bus} from "@/plugins/bus";
  import {isMobile} from "mobile-device-detect";
  import {IBus} from "@/interfaces/bus-actions";
  import AppMenuItemReport from "@/modules/Report/components/AppMenuItemReport.vue";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import AppMenuItemSettings from "@/modules/ParksConfig/components/AppMenuItemSettings.vue";

  enum IconType {
    Img = 'img',
    Icon = 'icon',
  }

@Component({
  components: {
    BarrierButton,
    BalanceMenuButton,
    AppMenuItemReport,
    AppMenuItemSettings,
  },
})
export default class AppMenu extends Vue {
  publicPath = process.env.VUE_APP_PUBLIC_URL;
  landingUrl = 'https://parkingmaster.ru/';
  reports = ICarList.Commands;
  mobileOpened = false;
  iconType = IconType;

  get isUser() { return this.$store.state.auth.isUser; }
  get anonymous() { return this.$store.state.route.query[ANONYMOUS_PAGE] ? JSON.parse(this.$store.state.route.query[ANONYMOUS_PAGE]) : false; }
  get refMode() { return this.$store.state.profile.refMode; }
  get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }
  get isAnonymousSupport() {
    let result = false;
    if (!Boolean(this.$store.state.auth.token) && !this.$store.state.auth.isUser && this.$route.name === ROUTE_NAME.PAGE_SUPPORT) {
      result = true;
    }
    return result;
  }
  get profileName() { return `Профиль\n${this.$store.state.auth.profileName}\n${this.$store.state.auth.login}`; }
  get mainLinks() {
    return [{
      displayCondition: this.isUser && !this.anonymous && this.userAccess,
      title: 'Главная',
      mobileTitle: 'Главная',
      pageName: ROUTE_NAME.HOME,
      iconType: IconType.Icon,
      iconName: 'house',
    }, {
      displayCondition: this.isUser && !this.anonymous && this.userAccess,
      title: this.profileName,
      mobileTitle: 'Профиль',
      pageName: ROUTE_NAME.PAGE_PROFILE,
      iconType: IconType.Icon,
      iconName: 'user',
    }, {
      displayCondition: this.isUser && !this.anonymous,
      title: 'Список автомобилей',
      pageName: ROUTE_NAME.PAGE_CAR_LIST,
      iconType: IconType.Icon,
      iconName: 'car',
      class: 'double-space',
    }, {
      specialTemplate: true,
      componentName: 'BarrierButton',
      displayCondition: this.isUser && !this.isAnonymousSupport && !this.userAccess.gateDisableFlag,
    }, {
      specialTemplate: true,
      componentName: 'AppMenuItemReport',
      displayCondition: true,
    }, {
      specialTemplate: true,
      componentName: 'BalanceMenuButton',
      displayCondition: this.isUser && !this.anonymous && !this.isAnonymousSupport
    }, {
      displayCondition: this.isUser && !this.anonymous,
      title: 'Оплатить по номеру',
      pageName: ROUTE_NAME.PAGE_SCREEN_PAY,
      iconType: IconType.Icon,
      iconName: 'credit-card',
    }, {
      specialTemplate: true,
      componentName: 'AppMenuItemSettings',
      displayCondition: this.isUser,
    }, {
      displayCondition: !this.isUser || this.anonymous,
      title: 'Войти в личный кабинет',
      pageName: ROUTE_NAME.PAGE_AUTHORIZATION,
      iconType: IconType.Img,
      iconName: 'login',
      class: 'line-space',
    }, {
      displayCondition: this.isUser && !this.anonymous,
      title: 'Выйти',
      action: () => this.onLogoutClick(),
      iconType: IconType.Img,
      iconName: 'logout',
      class: 'line-space',
    },];
  }

  mounted() {
    bus.$on(IBus.AppMenuAction.Display, () => this.toggleMobileMenu({ display: true }));
    bus.$on(IBus.AppMenuAction.Close, () => this.toggleMobileMenu({ display: false }));
  }

  menuLinkClick(menuItem) {
    this.toggleMobileMenu();
    if (menuItem.pageName) {
      if (menuItem.pageName !== this.$route.name) {
        let pagesNeedQuery = [];
        this.$store.dispatch('openPage', {routeName: menuItem.pageName, query: pagesNeedQuery.includes(menuItem.pageName) ? this.$route.query : null});
      }
    }
    else {
      menuItem.action();
    }
  }

  toggleMobileMenu(payload?: { display: boolean }) {
    if (isMobile) {
      if (payload) {
        this.mobileOpened = payload.display;
      }
      else {
        this.mobileOpened = !this.mobileOpened;
        if (!this.mobileOpened) {
          bus.$emit(IBus.AppMenuAction.Close);
        }
      }
    }
  }

  onLogoutClick() {
    this.toggleMobileMenu({ display: false });
    return this.$store.dispatch('auth/logoutConfirm');
  }

  async openPage(page: ROUTE_NAME) {
    this.toggleMobileMenu({ display: false });
    await this.$store.dispatch('openPage', {routeName: page});
  }

  async openFeedback() {
    this.toggleMobileMenu();
    await this.$store.dispatch('dialog/openDialog', { blockName: 'allPages', dialogName: 'feedbackPopup' });
  }

  destroyed() {
    bus.$off(IBus.AppMenuAction.Display);
    bus.$off(IBus.AppMenuAction.Close);
  }
}
